import { HandAccesibility } from "./hand-accesibility";

export class AssignOrderTab {

  static setTabsFromIndexDom(tabIndex:number, filter: string, idObj?:number): number {
    let i: number;
    let objDomAccesibility = HandAccesibility.DomObject.filter(a=>a.front===filter);

    for (i = 0; i < objDomAccesibility.length; i++) {

      let objName = objDomAccesibility[i].object;
      if (idObj!=null) objName = objName+'_'+idObj;
      let objDom = document.getElementById(objName);
      if (objDom!=null){
        tabIndex++;
        objDom.setAttribute("tabindex",tabIndex.toString());
      }
    }
    return tabIndex;
  }
}
